import React from "react";
import { Link, graphql, StaticQuery } from "gatsby";
import classNames from "classnames";
import useTranslation from "locales";

import "./mobile-menu.scss";

const MobileMenu = ({
  dismissed,
  mobile,
  data,
  gardensOptions,
  abtopt,
  lang,
  newsletter,
  onExit,
}) => {
  const langs = data.lang.nodes[0].languages;
  const { t } = useTranslation(lang);

  return (
    <div
      className={classNames(`mobile-menu`, {
        [`mobile-menu--overlay`]: mobile,
        [`mobile-menu--dismissed`]: dismissed,
      })}
    >
      <div className="mobile-menu__container">
        <ul className="mobile-menu__languages">
          {langs.map((item, index) => {
            return (
              <li key={index}>
                <Link
                  to={`/${item.slug}`}
                  className={classNames(`mobile-menu__languages-link`, {
                    [`active`]: item.slug === lang,
                  })}
                >
                  {item.code}
                </Link>
              </li>
            );
          })}
        </ul>
        <ul className="mobile-menu__gardens">
          <li className="mobile-menu__gardens-item">
            {t("Wybierz Ogród Świateł")}
          </li>
          {gardensOptions?.map((item, index) => {
            return (
              <li className="mobile-menu__gardens-item" key={index}>
                <a
                  href={item.url}
                  target="_blank"
                  rel="noreferrer nofollow"
                  className="mobile-menu__gardens-link"
                >
                  {item.tekst}
                </a>
              </li>
            );
          })}
        </ul>
        <ul className="mobile-menu__about">
          {abtopt.map((item, index) => {
            return (
              <li className="mobile-menu__about-item" key={index}>
                <Link to={item.url} className="mobile-menu__about-link">
                  {item.label}
                </Link>
              </li>
            );
          })}
        </ul>
        {newsletter ? (
          <Link
            className="btn mobile-menu__btn"
            to="/#newsletter"
            onClick={onExit}
          >
            {t("Zapis do newslettera")}
          </Link>
        ) : (
          <a
            href={t("https://bilety.ogrodswiatel.pl/")}
            className="btn mobile-menu__btn"
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            {t("Kup bilet")}
          </a>
        )}
      </div>
    </div>
  );
};

export default function MobileMenuStatic(props) {
  return (
    <StaticQuery
      query={graphql`
        {
          lang: allWp {
            nodes {
              languages {
                slug
                code
              }
            }
          }
        }
      `}
      render={(data) => <MobileMenu data={data} {...props} />}
    />
  );
}
